import script from "./InicioAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./InicioAdmin.vue?vue&type=script&setup=true&lang=js"

import "./InicioAdmin.vue?vue&type=style&index=0&id=68f60a01&lang=css"
import "./InicioAdmin.vue?vue&type=style&index=1&id=68f60a01&scoped=true&lang=css"

import exportComponent from "/var/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-68f60a01"]])

export default __exports__